import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import dynamic from "next/dynamic";
import { ReactElement } from "react";

import { RouteName } from "@/consts/RouteName";
import { commonTranslations } from "@/consts/pageTranslationNamespace";
import SiteLayout from "@/features/common/components/navigation/SiteLayout";
import { getServerSidePropswithApollo } from "@/server/graphql/apollo";
import { getEnabledFeatures } from "@/server/ssr/getEnabledFeatures";
import { isShowSensitiveContent } from "@/server/ssr/isShowSensitiveContent";
import { getLoginSession } from "@/services/auth/userCookies";

const HomePage = dynamic(
  () => import("@/features/section/components/home/HomePage"),
  { ssr: true },
);

function Home() {
  return <HomePage />;
}

export const getServerSideProps = getServerSidePropswithApollo(
  async ({ apolloClient, locale, req, query }) => {
    // Redirect to PostDetail page on previewing post detail
    if ("preview" in query) {
      return {
        redirect: {
          permanent: true,
          destination: `${RouteName.Post}/${encodeURIComponent(
            query.preview as string,
          )}`,
        },
        props: {},
      };
    }

    const { ssrUserId } = getLoginSession(req) ?? {};

    if (!ssrUserId) {
      return {
        redirect: {
          permanent: false,
          destination: RouteName.Landing,
        },
        props: {},
      };
    }

    const ssrShowSensitiveContent = await isShowSensitiveContent({
      apolloClient,
      ssrUserId,
      page: "home",
    });

    await getEnabledFeatures({ apolloClient, page: "home" });

    return {
      props: {
        ...(await serverSideTranslations(locale, [
          ...commonTranslations,
          "topWriters",
          "post",
          "landing",
        ])),
        ssrUserId,
        ssrShowSensitiveContent,
      },
    };
  },
);

Home.getLayout = function getLayout(page: ReactElement) {
  return <SiteLayout showFooter>{page}</SiteLayout>;
};

export default Home;
